var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("" + _vm.prefixCls),on:{"click":function($event){$event.preventDefault();return _vm.check($event)}}},[_c('Checkbox',{ref:"checkbox",class:(_vm.prefixCls + "-label"),attrs:{"label":_vm.label,"disabled":_vm.disabled,"checked":_vm.checked,"defaultChecked":_vm.defaultChecked,"name":_vm.name}},[_vm._t("default")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ab095dee","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/checkbox/agree-item.vue
// module id = null
// module chunks = 